import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { DeductionSummaries } from "../../../config/filingConstants";
import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import SvgImage from "../../SvgImage";
import { ContextAwareToggle } from "../../accordion";

type Props = {
  handleOnPressEdit: (tabName: IActiveTabs) => void;
};

const ReviewDeductions: React.FC<Props> = (props: Props) => {
  const { handleOnPressEdit } = props;

  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      <Accordion.Item eventKey="review-file-2">
        <Accordion.Header>
          <div className="btn-content">
            <SvgImage imgId="other-deductions-information" />
            <h4 className="mb-0">Deductions</h4>
          </div>
          <PreventEditComponent>
            <span
              role="button"
              className="btn btn-link"
              onClick={() => handleOnPressEdit("deductions")}
            >
              Edit
            </span>
          </PreventEditComponent>
        </Accordion.Header>
        <Accordion.Body>
          <hr />
          {values.TotalChapVIADeductions ? (
            <Accordion className="accordion-sm">
              <Accordion.Item eventKey="deductions-0">
                <ContextAwareToggle eventKey="deductions-0" isChild={true}>
                  <div className="btn-content justify-content-between">
                    <p className="leading-para fw-bold mb-0">Deduction Breakup</p>
                    <p className="leading-para fw-bold mb-0">
                      <PriceDisplay price={values.TotalChapVIADeductions} />
                    </p>
                  </div>
                </ContextAwareToggle>
                <Accordion.Body>
                  <section>
                    <dl className="eds-list eds-dl eds-inline-between">
                      {/* DeductionSummaries is used for display purpose only */}
                      {/* DeductUndChapVIA should be used for mapping */}
                      {Object.entries(values.DeductUndChapVIA).map(([key, value], index) => (
                        <React.Fragment key={`deduction-${index}`}>
                          {DeductionSummaries[key] && value ? (
                            <div className="eds-list--item">
                              <dt>{DeductionSummaries[key]}</dt>
                              <dd>
                                <PriceDisplay price={value} />
                              </dd>
                            </div>
                          ) : null}
                        </React.Fragment>
                      ))}
                    </dl>
                  </section>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : null}

          <dl className="eds-list eds-dl eds-inline-between">
            <div className="eds-list--item eds-list--item-total">
              <dt>Total Deduction</dt>
              <dd>
                <PriceDisplay price={values.TotalChapVIADeductions} />
              </dd>
            </div>
          </dl>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default ReviewDeductions;
